/* eslint-disable radix */
import React from 'react';
import { Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';
import useAuth from '../../hooks/useAuth';

const AdminAuthGuard = ({ children }) => {
  const { isAuthenticated, user } = useAuth();

  if (!isAuthenticated && user === null) {
    return <Redirect to="/login" />;
  }
  else if (isAuthenticated && user?.userType === "company") {
    return <Redirect to="/company/dashboard" />;
  }
  else if (isAuthenticated && user?.userType === "member") {
    // Members have no dashboard route — bounce to login.
    return <Redirect to="/login" />;
  }

  return (
    <>
      {children}
    </>
  );
};

AdminAuthGuard.propTypes = {
  children: PropTypes.node.isRequired,
};

export default AdminAuthGuard;
